import React, { Component } from 'react'
import View from './view'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import './style.css'
import ArrowIcon from '../../components/Icons/ArrowDown'
import { unSetUserInfo, toggleDrawer, toggleSnackBar } from '../../redux/actions'
import { isAllowed, ADMIN } from '../../util';

const mapDispatchToProps = dispatch => {
  return {
    unSetUserInfo: () => dispatch(unSetUserInfo()),
    toggleDrawer: () => dispatch(toggleDrawer()),
    toggleSnackBar: () => dispatch(toggleSnackBar(""))
  };
};

const mapStateToProps = state => {
  return {
    user: state.user,
    app: state.app,
  }
}


const subNavBarItems = [
  // {
  //   role: [ADMIN],
  //   label: "الحسابات",
  //   subNav: [
  //     { label: "شجرة الحسابات", url: "tree", role: [ADMIN] },
  //     { label: "انواع الحسابات", url: "accountsType", role: [ADMIN] },
  //     { label: "العمـلات", url: "currencies", role: [ADMIN] },
  //     { label: "اسعار الصرف", url: "currencies/exrate", role: [ADMIN] },
  //   ]
  // },
  // {
  //   role: [ADMIN],
  //   label: "المــواد",
  //   subNav: [
  //     { label: "أضافة مادة", url: "items", role: [ADMIN] },
  //     { label: "تعديل مادة", url: "items/edit", role: [ADMIN] },
  //     { label: "اقسام المواد", url: "dep", role: [ADMIN] },
  //     { label: "الاصنـاف", url: "itemsCategory", role: [ADMIN] },
  //     { label: "الانـواع", url: "itemsType", role: [ADMIN] },
  //     { label: "المخازن", url: "stores", role: [ADMIN] },
  //   ]
  // },
  // {
  //   role: [ADMIN],
  //   label: "المندوبين",
  //   subNav: [
  //     { label: "تحديد نقاط البيع", url: "salesman/poi", role: [ADMIN] },
  //     { label: "اجابات الرفض", url: "salesman/answers", role: [ADMIN] },
  //   ]
  // },
  // {
  //   role: [ADMIN],
  //   label: "وينك",
  //   subNav: [
  //     { label: "مزامنة الحسابات", url: "wenak/account/sync", role: [ADMIN] },
  //   ]
  // },
  {
    role: [ADMIN],
    label: "المستخدمين",
    subNav: [
      { label: "اضافة مستخدم", url: "users/add", role: [ADMIN] },
      { label: "تعديل مستخدم", url: "users/edit", role: [ADMIN] },
    ]
  },
]


class index extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
  }
  goto = link => () => {
    let { history } = this.props;
    history.push(`/settings/${link}`)
  }

  createNavBarItems = (items) => {
    let { user } = this.props
    return items.filter(i => isAllowed(user.user, i.role))
      .map((i, index) => <span key={index} className="flex justify-between parent w-1/8 relative mx-1" style={{ lineHeight: "50px" }}><span className="cursor-pointer mx-1" >{i.label}</span><ArrowIcon />
        <ul className="submenu bg-white absolute" style={{ top: "50px", zIndex: "9999" }}>
          {this.createSubNavBarItems(i.subNav.filter(e => isAllowed(user.user, e.role)))}
        </ul>
      </span>)
  }

  createSubNavBarItems = (items) => {
    return items.map((s, index) =>
      <li key={index}> <span onClick={this.goto(s.url)} className="w-32 block cursor-pointer mx-2">{s.label}</span> </li>
    )
  }

  render() {
    let items = this.createNavBarItems(subNavBarItems)
    return (
      <View
        items={items}
      />
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index))


